module.exports = __webpack_public_path__ + "img/undraw_game_day.9e4f75f1.svg";